export default __webpack_public_path__ + "static/media/s5.decce1ce.JPG";